// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import utils from './util/util'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import VueClipboard from 'vue-clipboard2'
import { FormModel } from 'ant-design-vue';

Vue.config.productionTip = false
Vue.config.domain = 'http:127.0.0.1:5505/'
Vue.config.api_version = 'api/'
Vue.use(Antd)
Vue.use(Vueaxios, axios)
Vue.use(VueClipboard)
Vue.use(FormModel);
// Vue.component(Select.option.name, Select.option)

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount("#app")

Vue.prototype.$utils = utils
